
import { defineComponent } from 'vue';
import { ValidationError } from '../utils/api';
export default defineComponent({
    name: 'ValidationErrors',
    props: {
        errors: Array<ValidationError>
    },
    computed: {
        hasErrors() {
            return this.errors && this.errors.length > 0;
        }
    }
});
